import Service from '@/api/Service'

const system = {
    state: {
        count: "",
        projectsystemList: [],
        projectsystemInfo: {},
    },
    mutations: {
        SET_COUNT: (state, count) => {
            state.count = count
        },
        SET_PROJECTSYSTEMLIST: (state, list) => {
            state.projectsystemList = list
        },
        SET_PROJECTSYSTEMINFO: (state, projectsystemInfo) => {
            state.projectsystemInfo = projectsystemInfo
        },
    },
    actions: {
        // 获取项目子系统列表
        async GetProjectSystemList({ commit }, parms) {
            let data = await Service.getProjectSystemList(parms);
            return new Promise((resolve, reject) => {
                if (data) {
                    let list = data.list === null ? [] : data.list;
                    commit('SET_COUNT',data.count)
                    commit('SET_PROJECTSYSTEMLIST', list)
                    resolve()
                }else{
                    reject()
                }
            })
        },
        // 获取当前子系统信息
        async GetProjectSystemInfo({ commit }, parms) {
            let data = await Service.getProjectSystemInfo(parms);
			
            return new Promise((resolve, reject) => {
                if (data) {
                    commit('SET_PROJECTSYSTEMINFO', data)
                    resolve(data)
                } else {
                    reject("no projectsystemId")
                }
            })
        }
    }
}

export default system
